/**
 * Systems
 *
 * GET_LIST
 */
export const RESOURCES = {
    'SystemsOp': {
        GET_LIST: function (params) {
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Systems',
                'uri': localStorage.getItem('server') + '/api/v5/op/subscriber/getAll'
            }
        }
    },
    'SystemsReport': {
        GET_LIST: function (params) {
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Systems',
                'uri': localStorage.getItem('server') + '/api/v5/report/subscriber/getAll'
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. 'Systems'
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}


// WEBPACK FOOTER //
// ./src/Fuse/fuseSystemsResourceMap.js